//
//
//
//
//
//
//
//
import create from "../../create";
export default create({
  name: "imgborder",
  computed: {
    styleImgName: function styleImgName() {
      var _this = this;

      return Object.assign({
        width: "100%",
        height: "100%",
        backgroundColor: this.option.backgroundColor || "rgba(180, 181, 198, 0.1)",
        backgroundClip: "padding-box",
        opacity: this.option.opacity || 1,
        filter: "blur(0px)"
      }, function () {
        if (!_this.validatenull(_this.dataChart)) {
          return {
            borderImageSource: "url(" + _this.dataChart + ")",
            borderImageSlice: "10 16 15 10 fill",
            borderWidth: "10px 16px 15px 10px",
            borderStyle: "solid",
            boxSizing: "border-box"
          };
        }

        return {};
      }());
    }
  },
  methods: {
    handleClick: function handleClick() {
      this.clickFormatter && this.clickFormatter({
        data: this.dataChart
      }, this.getItemRefs());
    }
  }
});